import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import { red } from '@material-ui/core/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import moment from 'moment'
import { Link } from 'react-router-dom'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import Grid from '@material-ui/core/Grid';




const useStyles = makeStyles((theme) => ({
  root: {
    width: '80%',
    margin: 'auto',
    maxWidth: 800
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

const FormSummary = ({ id, formTitle, editButtonTitle, addButtonTitle, createdAt, inputs }) => {
  const classes = useStyles();
  
  const deleteNav = () => {
  }

  return (
    <div>
      <Card style={{ margin: 20 }}>
        <CardHeader style={{ padding: 10 }}
          avatar={
            <Avatar aria-label="recipe" className={classes.avatar}>A</Avatar>
          }
          title={formTitle}
          subheader={moment(createdAt.toDate()).calendar()}
        />
        <CardContent style={{ padding: 10 }}>
          <Typography variant="body2" color="textSecondary" component="p">Edit Button : {editButtonTitle}</Typography>
          <Typography variant="body2" color="textSecondary" component="p">Add Button : {addButtonTitle}</Typography>
          <Grid container spacing={3}>
          {
          inputs && inputs.length ? inputs.map(({id, title, defaultValue, isRequired, showOn}) => {
            return (
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="textSecondary" component="p">id : {id}</Typography>
                <Typography variant="body2" color="textSecondary" component="p">title : {title}</Typography>
                <Typography variant="body2" color="textSecondary" component="p">defaultValue : {defaultValue}</Typography>
                <Typography variant="body2" color="textSecondary" component="p">isRequired : {isRequired}</Typography>
                <Typography variant="body2" color="textSecondary" component="p">showOn : {showOn}</Typography>
              </Grid>
            )
          })
            : null
        }
        </Grid>

        </CardContent>
        <CardActions disableSpacing style={{ padding: 0 }}>
          <IconButton aria-label="add to favorites" onClick={deleteNav}>
            <DeleteIcon />
          </IconButton>
          <Link to={'/edit-form/' + id}>
            <IconButton aria-label="share">
              <EditIcon />
            </IconButton>
          </Link>
        </CardActions>
      </Card>
    </div>
  )
}

export default FormSummary